import React, { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import apiClient from "../../../../services/api-client";
import StorageHelper from '../../../../utils/storage-helper';
import DataTableCard from '../../../../components/ui/DataTableCard';
import { useFetchList } from '../../../../hooks/useFetchList';

const COLUMNS = [
  { field: 'index', header: '#' },
  { field: 'BankID', header: 'BANK ID' },
  { field: 'BankName1', header: 'Bank Name' },
];

export default function LoanHistory() {
  const toast = useRef(null);
  const { rows, reload } = useFetchList('policy/banks');
  const [loadingBanks, setLoadingBanks] = useState(false);

  const getBanksFromEasipol = async () => {
    setLoadingBanks(true);
    try {
      const response = await apiClient.get('policy/banks/easipol', {
        headers: {
          Authorization: 'Bearer ' + StorageHelper.get('token'),
          'Content-Type': 'application/json'
        }
      });

      if (response.data.status === 'SUCCESS') {
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'You have pulled banks from easipol' });
        await reload();
      }
    } finally {
      setLoadingBanks(false);
    }
  };

  const syncButton = (
    <button className="btn btn-primary rounded-full h-10 min-h-0 shadow-sm px-6" onClick={getBanksFromEasipol}>
      <i className="pi pi-sync"></i> Synchronise Easipol
    </button>
  );

  return (
    <>
      <Toast ref={toast} />
      <DataTableCard
        title="Active Banks List"
        exportName="Banks"
        columns={COLUMNS}
        rows={rows.map((item, index) => ({ ...item, index: index + 1 }))}
        loading={loadingBanks}
        emptyMessage="No Banks found"
        toolbarExtras={syncButton}
        exportDisabled={false}
      />
    </>
  );
}
